import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, TextField, IconButton, CircularProgress, Alert
} from '@mui/material';
import { Close as CloseIcon, Cancel as CancelIcon } from '@mui/icons-material';
import empresasApi from '../../../api/empresasApi';

export default function DialogRechazarNegocio({ open, negocio, onClose, onRechazado }) {
  const [motivo, setMotivo] = useState('');
  const [procesando, setProcesando] = useState(false);
  const [error, setError] = useState('');

  const handleRechazar = async () => {
    if (!motivo.trim()) {
      setError('Debes indicar un motivo de rechazo');
      return;
    }

    setProcesando(true);
    setError('');
    try {
      await empresasApi.rechazarNegocio(negocio.id, motivo);
      if (onRechazado) onRechazado();
      handleCerrar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al rechazar');
    } finally {
      setProcesando(false);
    }
  };

  const handleCerrar = () => {
    if (!procesando) {
      setMotivo('');
      setError('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleCerrar} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ borderBottom: '2px solid #FEE2E2' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <CancelIcon sx={{ color: '#EF4444', fontSize: 32 }} />
            <Box>
              <Typography variant="h6" fontWeight="bold">Rechazar Negocio</Typography>
              <Typography variant="body2" color="text.secondary">{negocio?.nombre}</Typography>
            </Box>
          </Box>
          <IconButton onClick={handleCerrar} disabled={procesando}><CloseIcon /></IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Se notificará a <strong>{negocio?.correo_contacto}</strong> con el motivo del rechazo.
        </Typography>

        <TextField
          fullWidth multiline rows={3}
          label="Motivo del rechazo *"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          disabled={procesando}
          placeholder="Ej: Documentación incompleta, datos inválidos, empresa duplicada..."
        />
      </DialogContent>

      <DialogActions sx={{ borderTop: '2px solid #F5F5F5', px: 3, py: 2 }}>
        <Button onClick={handleCerrar} disabled={procesando} color="inherit">Cancelar</Button>
        <Button
          onClick={handleRechazar} variant="contained" disabled={procesando || !motivo.trim()}
          startIcon={procesando ? <CircularProgress size={20} /> : <CancelIcon />}
          sx={{ bgcolor: '#EF4444', '&:hover': { bgcolor: '#DC2626' }, fontWeight: 'bold', px: 3 }}
        >
          {procesando ? 'Rechazando...' : 'Rechazar Negocio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
